import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class DryUnitWeightGamaDCalculationMethodModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (DryUnitWeightGamaDCalculationMethodModel._instance == null) DryUnitWeightGamaDCalculationMethodModel._instance = new DryUnitWeightGamaDCalculationMethodModel(authManager);
        return DryUnitWeightGamaDCalculationMethodModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/dry-unit-weight-gama-d-calculation-methods', 'geo-sections/dry-unit-weight-gama-d-calculation-methods/codelist');

        this.entityName = 'geo-sections.DryUnitWeightGamaDCalculationMethod';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Dry Unit Weight Gama D Calc Method';
        this.setLabel = 'Dry Unit Weight Gama D Calc Methods';

        this.browser = {
            name: 'default-geo-sections-dryunitweightgamadcalculationmethod-browser',
            moduleName: 'default-geo-sections-dryunitweightgamadcalculationmethod-browser',
            moduleTitle: 'Dry Unit Weight Gama D Calc Methods',
            moduleStateSlotName: 'default-geo-sections-dryunitweightgamadcalculationmethod-browser',
        };

        this.editor = {
            name: 'default-geo-sections-dryunitweightgamadcalculationmethod-editor',
            moduleName: 'default-geo-sections-dryunitweightgamadcalculationmethod-editor',
            moduleTitle: 'Dry Unit Weight Gama D Calc Method',
            moduleStateSlotName: 'default-geo-sections-dryunitweightgamadcalculationmethod-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
